import { Link } from 'react-router-dom';
import type { BlogPost } from '../lib/blog';
import { Icon } from '../lib/icons';

const imageStyles: Record<string, string> = {
  'lead-intake': 'from-brand-navy via-brand-dark to-brand-teal',
  'network-closet': 'from-brand-dark via-brand-navy to-slate-500',
  'internal-tools': 'from-brand-navy via-slate-700 to-brand-teal',
  'managed-hosting': 'from-brand-dark via-brand-navy to-cyan-800',
  'practical-ai': 'from-brand-navy via-brand-dark to-brand-tealLight'
};

export function BlogImage({ image, title }: { image: string; title: string }) {
  return (
    <div className={`relative aspect-[16/10] overflow-hidden rounded-md bg-gradient-to-br ${imageStyles[image] ?? imageStyles['lead-intake']}`}>
      <div className="absolute inset-0 engineering-grid opacity-30" />
      <div className="absolute left-5 top-5 rounded-md border border-white/20 bg-white/10 p-3 text-white backdrop-blur">
        <Icon name={image === 'network-closet' ? 'network' : image === 'practical-ai' ? 'brain' : 'fileText'} className="h-6 w-6" />
      </div>
      <div className="absolute bottom-5 left-5 right-5">
        <p className="text-sm font-bold uppercase tracking-[0.14em] text-brand-tealLight">{title.split(' ')[0]}</p>
      </div>
    </div>
  );
}

export function BlogCard({ post }: { post: BlogPost }) {
  return (
    <article className="group overflow-hidden rounded-lg border border-brand-border bg-white shadow-card transition duration-200 hover:-translate-y-1 hover:shadow-soft">
      <Link to={`/blog/${post.slug}`} aria-label={`Read ${post.title}`}>
        <BlogImage image={post.image} title={post.title} />
        <div className="p-6">
          <div className="flex flex-wrap items-center gap-3 text-xs font-bold uppercase tracking-[0.12em] text-brand-teal">
            <span>{post.category}</span>
            <span className="h-1 w-1 rounded-full bg-brand-border" />
            <span>{post.readTime}</span>
          </div>
          <h2 className="mt-4 font-display text-2xl leading-tight text-brand-dark">{post.title}</h2>
          <p className="mt-3 text-sm leading-7 text-brand-muted">{post.summary}</p>
          <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-brand-navy">
            Read article <Icon name="arrowRight" className="h-4 w-4 transition group-hover:translate-x-1" />
          </span>
        </div>
      </Link>
    </article>
  );
}
